import React, { useState, useEffect } from 'react';
import BarraFiltros, { SinResultados } from './BarraFiltros';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'; // Importar SweetAlert2
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    TextField,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash, faEye, faUndo } from '@fortawesome/free-solid-svg-icons';

function AlmacenesPage() {
    const [almacenes, setAlmacenes] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentAlmacen, setCurrentAlmacen] = useState(null);
    const [newAlmacen, setNewAlmacen] = useState({
        nombre_almacen: '',
        direccion: '',
    });
    const [search, setSearch] = useState('');
    const [estado, setEstado] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchAlmacenes();
    }, []);

    const fetchAlmacenes = async () => {
        try {
            const response = await axios.get('https://api.hmsaa.com.mx:5001/api/almacenes');
            setAlmacenes(response.data);
        } catch (err) {
            console.error('Error al cargar los almacenes:', err);
            Swal.fire('Error', 'No se pudieron cargar los almacenes. Intenta de nuevo.', 'error');
        }
    };

    // NUEVA FUNCIÓN PARA DESHABILITAR
    const handleDisableAlmacen = async (almacenId) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(
                `https://api.hmsaa.com.mx:5001/api/almacenes/${almacenId}`,
                { is_disabled: true },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            Swal.fire('Éxito', 'El almacén se ha deshabilitado correctamente.', 'success');
            fetchAlmacenes();
        } catch (error) {
            console.error('Error al deshabilitar el almacén:', error);
            Swal.fire('Error', 'No se pudo deshabilitar el almacén. Intenta de nuevo.', 'error');
        }
    };

    const handleAddAlmacen = () => {
        setEditMode(false);
        setNewAlmacen({ nombre_almacen: '', direccion: '' });
        setDialogOpen(true);
    };

    const handleEditAlmacen = (almacen) => {
        setEditMode(true);
        setCurrentAlmacen(almacen);
        setNewAlmacen({ ...almacen });
        setDialogOpen(true);
    };

    const handleSaveAlmacen = async () => {
        const url = editMode
            ? `https://api.hmsaa.com.mx:5001/api/almacenes/${currentAlmacen.id_almacen}`
            : 'https://api.hmsaa.com.mx:5001/api/almacenes';
        try {
            const token = localStorage.getItem('token');
            // Verifica que los campos no estén vacíos
            if (!newAlmacen.nombre_almacen.trim() || !newAlmacen.direccion.trim()) {
                Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
                return;
            }
            const payload = {
                nombre_almacen: newAlmacen.nombre_almacen,
                direccion: newAlmacen.direccion
            };
            // Si es edición y estás cambiando el estado, incluye is_disabled
            if (editMode && currentAlmacen.is_disabled !== undefined) {
                payload.is_disabled = currentAlmacen.is_disabled;
            }
            const response = editMode
                ? await axios.put(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                : await axios.post(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
            setDialogOpen(false);
            Swal.fire('Éxito', `El almacén se ha ${editMode ? 'actualizado' : 'creado'} correctamente.`, 'success');
            fetchAlmacenes();
        } catch (error) {
            console.error('Error completo:', error);
            // Muestra mensajes de error más específicos
            if (error.response) {
                if (error.response.status === 422) {
                    Swal.fire('Error de validación', 'Revise los datos ingresados', 'error');
                } else if (error.response.data && error.response.data.error) {
                    Swal.fire('Error', error.response.data.error, 'error');
                } else {
                    Swal.fire('Error', 'Ocurrió un error al procesar la solicitud', 'error');
                }
            } else {
                Swal.fire('Error', 'No se pudo conectar con el servidor', 'error');
            }
        }
    };

    const handleEnableAlmacen = async (almacenId) => {
        try {
            const token = localStorage.getItem('token'); // Obtener el token JWT
            await axios.put(
                `https://api.hmsaa.com.mx:5001/api/almacenes/${almacenId}`,
                { is_disabled: false },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            Swal.fire('Éxito', 'El almacén se ha habilitado correctamente.', 'success');
            fetchAlmacenes();
        } catch (error) {
            console.error('Error al habilitar el almacén:', error);
            Swal.fire('Error', 'No se pudo habilitar el almacén. Intenta de nuevo.', 'error');
        }
    };

    const handleViewAlmacen = (almacenId) => {
        navigate(`/almacen/${almacenId}`);
    };

    // DECLARACIÓN CORRECTA DE filteredAlmacenes
    const termino = search.trim().toLowerCase();

    const filteredAlmacenes = almacenes.filter((almacen) =>
        (estado === '' || (estado === 'deshabilitados') === Boolean(almacen.is_disabled)) &&
        [almacen.nombre_almacen, almacen.direccion].some((v) =>
            (v ?? '').toString().toLowerCase().includes(termino)
        )
    );

    const limpiarFiltros = () => {
        setSearch('');
        setEstado('');
    };

    return (
        <div>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Gestión de Almacenes
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleAddAlmacen}
                        startIcon={<FontAwesomeIcon icon={faPlus} />}
                    >
                        Agregar Almacén
                    </Button>
                </Toolbar>
            </AppBar>

            <BarraFiltros
                busqueda={search}
                onBusqueda={setSearch}
                placeholder="Buscar por nombre o dirección"
                filtros={[
                    {
                        id: 'estado',
                        tipo: 'chips',
                        etiqueta: 'Estado',
                        valor: estado,
                        onChange: setEstado,
                        opciones: [
                            { valor: '', etiqueta: 'Todos' },
                            { valor: 'activos', etiqueta: 'Activos' },
                            { valor: 'deshabilitados', etiqueta: 'Deshabilitados' },
                        ],
                    },
                ]}
                total={almacenes.length}
                mostrados={filteredAlmacenes.length}
                onLimpiar={limpiarFiltros}
            />
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    justifyContent: 'center',
                    padding: 2,
                }}
            >
                {filteredAlmacenes.length === 0 && (
                    <SinResultados total={almacenes.length} onLimpiar={limpiarFiltros} entidad="almacenes" />
                )}
                {filteredAlmacenes.map((almacen) => (
                    <Box
                        key={almacen.id_almacen}
                        sx={{
                            border: '1px solid #ddd',
                            borderRadius: '15px',
                            padding: 2,
                            textAlign: 'center',
                            maxWidth: '300px',
                            width: '100%',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fff',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: 'auto',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            opacity: almacen.is_disabled ? 0.5 : 1,
                            '&:hover': {
                                transform: 'scale(1.05)',
                                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
                            },
                        }}
                    >
                        <Typography variant="h6" sx={{ marginBottom: 2 }}>
                            {almacen.nombre_almacen}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 2 }}>
                            {almacen.direccion}
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1 }}>
                            <Button
                                onClick={() => handleViewAlmacen(almacen.id_almacen)}
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                }}
                                startIcon={<FontAwesomeIcon icon={faEye} />}
                                disabled={almacen.is_disabled}
                            >
                                Ver
                            </Button>
                            <Button
                                onClick={() => handleEditAlmacen(almacen)}
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                }}
                                startIcon={<FontAwesomeIcon icon={faEdit} />}
                                disabled={almacen.is_disabled}
                            >
                                Editar
                            </Button>
                            <Button
                                onClick={() =>
                                    almacen.is_disabled
                                        ? handleEnableAlmacen(almacen.id_almacen)
                                        : handleDisableAlmacen(almacen.id_almacen)
                                }
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: almacen.is_disabled ? '#28a745' : '#dc3545',
                                    color: 'white',
                                }}
                            >
                                {almacen.is_disabled ? 'Habilitar' : 'Deshabilitar'}
                            </Button>
                        </Box>
                    </Box>
                ))}
            </Box>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>{editMode ? 'Editar Almacén' : 'Agregar Almacén'}</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Nombre del Almacén"
                        fullWidth
                        value={newAlmacen.nombre_almacen}
                        onChange={(e) => setNewAlmacen({ ...newAlmacen, nombre_almacen: e.target.value })}
                        sx={{ marginBottom: 2, marginTop: 1 }}
                    />
                    <TextField
                        label="Dirección"
                        fullWidth
                        value={newAlmacen.direccion}
                        onChange={(e) => setNewAlmacen({ ...newAlmacen, direccion: e.target.value })}
                        sx={{ marginBottom: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} color="secondary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSaveAlmacen} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AlmacenesPage;